import { SVGProps } from 'react';

export const ContractTerms = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 6.38306H4V5.38306H8V6.38306ZM8 9.38306H2V8.38306H8V9.38306ZM8 12.3831H2V11.3831H8V12.3831ZM19 0.383057H17V9.38306L15 7.38306L13 9.38306V0.383057H12C11.735 0.383057 11.48 0.488057 11.293 0.676057L10 1.96906L8.707 0.676057C8.52 0.488057 8.265 0.383057 8 0.383057H1C0.448 0.383057 0 0.831057 0 1.38306V14.3831C0 14.9351 0.448 15.3831 1 15.3831H7.586L9.293 17.0901C9.488 17.2851 9.744 17.3831 10 17.3831C10.256 17.3831 10.512 17.2851 10.707 17.0901L12.414 15.3831H19C19.552 15.3831 20 14.9351 20 14.3831V1.38306C20 0.831057 19.552 0.383057 19 0.383057V0.383057Z"
      fill="currentColor"
    />
  </svg>
);
